import { ITypeSite } from '@/app/shared/store/layout.store'

export const styleMobileModal = (slug: string) => {
  return {
    wrapper: '!overflow-hidden',
    base: 'bg-primary h-[100dvh] rounded-none !mx-0 w-full shadow-none',
    body: 'p-[20px_30px] extraMobile:p-[20px_50px_50px_50px] overflow-auto',
    backdrop: 'bg-white',
    closeButton: `z-[99999] flex p-1 items-center justify-center hover:bg-${slug} border-2 border-black bg-${slug} w-[34px] h-[34px] [&>svg]:w-full [&>svg]:h-full [&>svg]:text-primary [&>svg]:stroke-3 active:bg-${slug} top-[24px] right-[24px]`,
  }
}

export const getTypeSitePseudo = (slug: ITypeSite) => {
  switch (slug) {
    case 'online': {
      return 'before:bg-secondary after:bg-secondary'
    }
    default: {
      return 'before:bg-success after:bg-success'
    }
  }
}
